import PressCalendariumBlock from './PressCalendariumBlock';

export default PressCalendariumBlock;
